import api from '../token';

export const ListFornecedorInativo = async () => {
  try {
    const response = await api.post('/getFornecedorInativo');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

